import React, { useState, useEffect } from 'react';
import { Box, Grid, Card, CardContent, CardActions, Typography, Button } from '@mui/joy';
import { FaShoppingCart } from 'react-icons/fa';
import { useOutletContext } from 'react-router-dom';
import '../../styles/Tentes.css';
import kkk from '../../assets/tente.webp';
import ServiceSection from "./ServiceSectionTentes";
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import tente from "../../assets/tente.webp";
import { useNavigate } from "react-router-dom";
import { useCart } from "../CartContext";


const Cardi = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { addToCart } = useOutletContext();
        const { cart, setCart, cartCount, setCartCount } = useCart();
  

  const [categories, setCategories] = useState({});
  const [translatedTents, setTranslatedTents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const lang = localStorage.getItem('language') || 'FR';
  const newlang = { FRA: 'FR', ENG: 'EN', ESP: 'ES', POT: 'PT' }[lang] || 'FR';

  const translateText = async (text, targetLanguage) => {
    if (targetLanguage === 'FR' || targetLanguage === '') {
      return text; // Si la langue cible est déjà le français, ne traduisez pas.
    }
    const apiKey = process.env.REACT_APP_DEEPL_API_KEY;

    const url = process.env.REACT_APP_DEEPL_URL;

    const params = new URLSearchParams();
    params.append("auth_key", apiKey);
    params.append("text", text);
    params.append("target_lang", targetLanguage);
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
      });

      const data = await response.json();
      if (data.translations && data.translations[0]?.text) {
        return data.translations[0].text;
      }
      return text; // Retourne le texte d'origine si la traduction échoue
    } catch (error) {
      console.error('Erreur lors de la traduction :', error);
      return text;
    }
  };

  const checkStockAndAddToCart = async (tent) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/shop/inventory?tickets=1`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': process.env.REACT_APP_API_KEY,
        },
      });
      if (!response.ok) {
        if (response.status === 500) {
          // Redirection vers la page 500
          navigate("/500");
        }
        throw new Error(`Erreur HTTP : ${response.status}`);
      }

      const data = await response.json();
      const tentQuantity = data?.data?.tent_quantity;

      if (tentQuantity > 0) {
        addToCart(
          `tente-${tent.id}`,
          tent.name,
          tent.price,
          tent.type,
          tent.image || {tente},
          tent.description
        );
      } else {
        toast.error(t('stock.out_of_stock'));
      }
    } catch (err) {
      toast.error(t('stock.error_checking'));
    }
  };


  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/shop/tentes`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-API-Key': process.env.REACT_APP_API_KEY,

          },
        });
        if (!response.ok) {
          if (response.status === 500) {
            // Redirection vers la page 500
            navigate("/500");
          }
          throw new Error(`Erreur HTTP : ${response.status}`);
        }

        const data = await response.json();
        setCategories(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const translateTents = async () => {
      if (!categories.tents) return;

      const translated = await Promise.all(
        categories.tents.map(async (tent) => {
          const translatedName = await translateText(tent.name, newlang);
          const translatedDescription = await translateText(tent.description, newlang);
          return {
            ...tent,
            name: translatedName,
            description: translatedDescription,
          };
        })
      );

      setTranslatedTents(translated);
    };

    translateTents();
  }, [categories, newlang]);


  return (
    <div>
      <div className="camping-container">
        <h1 className="camping-title">{t('camping.title')}</h1>
        <div className="camping-content">
          <img src={kkk} alt="Tente de camping" className="camping-image" />
          <div className="camping-texteo-aj">
            <h5>{t('camping.description1')}</h5>
            <h5>{t('camping.description2')}</h5>
          </div>
        </div>
      </div>
      <Box sx={{ flexGrow: 1, padding: 4 }}>
  <Grid container spacing={2} justifyContent="center">
    <ToastContainer position="top-right" autoClose={800} />
    {translatedTents.length > 0 ? (
      translatedTents.map((tent) => (
        <Grid
          item
          xs={12}  // Une seule carte sur petits écrans
          sm={6}   // Deux cartes sur écrans moyens
          md={6}   // Deux cartes sur écrans grands
          lg={6}   // Deux cartes sur écrans très grands
          key={tent.id}
        >
          <Card
            variant="solid"
            color="primary"
            invertedColors
            sx={{
              boxShadow: 'lg',
              maxWidth: 1000, // Limite la largeur de chaque carte
              width: '95%', // Permet aux cartes de rester adaptatives
              height: 'auto', // Hauteur dynamique
              backgroundColor: '#f8f9fa',
              opacity: 1,
              margin: 'auto',
            }}>
            <div>
              <Typography level="h3" sx={{ color: '#c62828', textAlign: 'center' }}>
                {Number(tent.price).toLocaleString('fr-FR', { maximumFractionDigits: 0 })} FCFA
              </Typography>
            </div>
            <CardContent>
              <Typography level="title-lg" sx={{ color: '#333', textAlign: 'center' }}>
                {tent.name}
              </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center' }}>
              <Button
                onClick={() => checkStockAndAddToCart(tent)}
                variant="solid"
                sx={{
                  color: '#fff',
                  backgroundColor: '#c62828',
                  '&:hover': {
                    backgroundColor: '#fff',
                    color: '#c62828',
                    border: '2px solid #c62828',
                  },
                }}
              >
                <FaShoppingCart style={{ marginRight: '10px' }} />
                {t('card.add_to_cart')}
              </Button>
            </CardActions>
          </Card>
        </Grid>
      ))
    ) : (
      <Typography level="body-lg" sx={{ textAlign: 'center', margin: '20px auto' }}>
        {t('card.no_product')}
      </Typography>
    )}
  </Grid>
</Box>


      <div>
        <ServiceSection />
      </div>
    </div>
  );
};

export default Cardi;
